import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString, nullableStringArray } from '../utils/wire-value-utils';

/**
 * An organization's own chemical (not in the EPA book), built from the hub's custom chemical JSON
 * (`data-models/custom-chemical.ts`).
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class CustomChemical extends Base {
  // Writable fields
  name?: string | null;
  epaNumber?: string | null;
  manufacturer?: string | null;
  activeIngredient?: string | null;
  /** CAUTION, WARNING or DANGER. */
  signalWord?: string | null;
  category?: string | null;
  formulation?: string | null;
  rei?: string | null;
  phi?: string | null;
  defaultRate?: string | null;
  targetPests?: string[] | null;
  crops?: string[] | null;
  notes?: string | null;

  // Read-only
  organizationId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.epaNumber = nullableString(source['epaNumber']);
    this.manufacturer = nullableString(source['manufacturer']);
    this.activeIngredient = nullableString(source['activeIngredient']);
    this.signalWord = nullableString(source['signalWord']);
    this.category = nullableString(source['category']);
    this.formulation = nullableString(source['formulation']);
    this.rei = nullableString(source['rei']);
    this.phi = nullableString(source['phi']);
    this.defaultRate = nullableString(source['defaultRate']);
    this.targetPests = nullableStringArray(source['targetPests']);
    this.crops = nullableStringArray(source['crops']);
    this.notes = nullableString(source['notes']);
    this.organizationId = nullableString(source['organizationId']);
  }
}
